import React, { Component } from 'react';
import PropTypes from 'prop-types';

class InternalLink extends Component {

  static get propTypes() {
    return {
      color: PropTypes.string,
    };
  }

  constructor() {
    super();
    this.state = {
      isSmallScreen: false,
      isSidebarShow: false,
      config: [],
    };
  }

  componentDidMount() {

  }

  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" id="prefix__icon_s_internal-link" width="30" height="30" viewBox="0 0 30 30">
        <g id="prefix__Group_134" data-name="Group 134" transform="translate(4.5 4.5)">
            <path id="prefix__Path_214" d="M245.747 442.149a4.125 4.125 0 0 1-2.917-7.042l3.712-3.712a.75.75 0 1 1 1.06 1.06l-3.712 3.712a2.625 2.625 0 0 0 1.856 4.481 2.606 2.606 0 0 0 1.855-.768l5.039-5.039a2.628 2.628 0 0 0 0-3.712.75.75 0 0 1 1.061-1.06 4.13 4.13 0 0 1 0 5.833l-5.039 5.039a4.1 4.1 0 0 1-2.915 1.208z" className="prefix__cls-1" data-name="Path 214" transform="translate(-241.622 -421.438)"/>
            <path id="prefix__Path_215" d="M263.159 419.718a.746.746 0 0 1-.53-.22 4.122 4.122 0 0 1 0-5.833l5.039-5.039a4.125 4.125 0 0 1 5.833 5.834l-3.713 3.712a.75.75 0 1 1-1.06-1.06l3.713-3.712a2.625 2.625 0 1 0-3.713-3.712l-5.038 5.039a2.623 2.623 0 0 0 0 3.712.75.75 0 0 1-.53 1.28z" className="prefix__cls-1" data-name="Path 215" transform="translate(-253.995 -407.42)"/>
        </g>
        <path id="prefix__Rectangle_55" d="M0 0H30V30H0z" data-name="Rectangle 55" style={{ fill: 'none' }}/>
      </svg>
    );
  }
}

export default InternalLink;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/components/Layout/components/InternalLink/index.js
 **/